<!--

Component to let top level admins create, delete, modify,
and assign persmissions to sub users.

-->
<template>
  <div class="row border m-2 mt-5">
      <!-- add users -->
    <div class="col">
      <div class="row">
        <div class="col">
          <h2 class="text-underline mt-3 mb-3">Add A New User</h2>
          <div class="row">
            <div class="col-md-4 p-2">
              <span class="">Username </span>
              <input type="text" v-model="username"/>
            </div>

            <div class="col-md-4 p-2">
              <span class="">Password </span>
              <input type="password" v-model="password"/>
            </div>

            <div class="col-md-4 p-2 item-end">
              <span class="">User Role </span>
                <select v-model="role">
                  <option v-bind:value="3">Normal</option>
                  <option v-bind:value="2">Admin</option>
                </select>

              <button type="button" @click="addUser()" class="btn btn-primary ml-3">Add User</button>
            </div>
          </div>

          <div class="row">
            <div class="col">
              
            </div>
          </div>
        </div>
      </div>
      <!-- end add users -->

      <!-- button to hide/show user data -->
      <div class="row mt-2 mb-4">
        <div class="col">
          <button type="button" @click="toggleUser()" class="btn btn-dark">View Users</button>
        </div>
      </div>

      <!-- user data container -->
      <div v-if="userStatus">

        <!-- search results for large screens -->
        <div class="row justify-start align-items-center mt-5 ml-1 mb-3 d-none d-md-block">

          <table class="table">
            <thead class="rec-table-header">
              <tr>
                <!-- <th scope="col">Id</th> -->
                <th scope="col">Username</th>
                <th scope="col">Role</th>
                <th scope="col">Edit User Data</th>
              </tr>
            </thead>
            <tbody>

              <tr v-for="user in userList" class="clickable">
                <td>{{user.username}}</td>
                <td>{{user.role}}</td>
                <td><button type="button" @click="editUser(user.id)" class="btn btn-primary">Edit User</button></td>
              </tr>

            </tbody>
          </table>

          <div class="col" v-if="editStatus">
            <div class="row">
              <edit-user class="col" :user-id="editId" @userRefresh="editComplete()"></edit-user>
            </div>
          </div>

        </div>

      </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import EditUser from './EditUser.vue'

export default {
  components: {
    EditUser
  },
  data () {
    return {
      username: "",
      password: "",
      role: "",
      userStatus: "",
      editStatus: "",
      editId: "",
      gotUsers: false,
      userList: []
    }
  },
  methods: {
    makeMoney: function() {
      this.saveOpened = true
    },
    
    toggleUser: function() {
      //only fetch users once per toggle
      if (this.gotUsers == false) {
        this.fetchUsers()
      }

      if (this.userStatus == "") {
        this.userStatus = "true"
      } else {
        this.userStatus = ""
      }
    },

    fetchUsers: function() {
      let local = this

      //ajax query
      axios({
          method: 'get',
          url: local.$helpers.api() + '/admin/users',
          data: {},
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          local.gotUsers = true
          local.userList = response.data
        })
        .catch(function (error) {
          console.log("not logged in: ", error)
        });
    },

    addUser: function() {
      let local = this
      let creds = {}
      creds.username = this.username
      creds.password = this.password
      creds.role = this.role

      //ajax query
      axios({
          method: 'post',
          url: local.$helpers.api() + '/admin/user/add',
          data: creds,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //refresh user list
          local.clearForm()
          local.fetchUsers()
        })
        .catch(function (error) {
          console.log("not logged in: ", error)
        });
    },

    editUser: function(id) {
      //add user to edit, or close panel if open already
      if (this.editId == id) {
        this.editStatus = ""
        this.editId = ""
      } else {
        this.editId = id
        this.editStatus = "true"
      }
    },

    editComplete: function() {
      this.fetchUsers()
      this.editStatus = ""
      this.editId = ""
    },

    clearForm: function() {
      this.username = ""
      this.password = ""
      this.role = undefined
    }
  }
}
</script>

<style scoped>
  .user-table tr td {
    padding: 1.0em;
  }
</style>
